import { PlecaMorada } from "../../../utilities/PlecaMorada";
import Introduccion from "./introduccion";
import Recuadros from "./recuadros";

export default function Main(){
    window.scrollTo(0, 0)
    localStorage.setItem("seccion",'Colecciones /');
    return(
        <>
            <Introduccion/>       
            <div className="container mt-4">
                <div className="row justify-content-center">
                    <div className="col-11 back_purple title_collections text-center">
                        <h1 className="text_white py-2 mb-0">Colecciones</h1>
                    </div>
                    <div className="col-11 mt-3">
                        <div className="row">
                            <Recuadros/>
                        </div>
                    </div>
                </div>
            </div>
            <PlecaMorada/>
        </>
    )
}
